import { useEffect } from 'react';

import { useNewYearSeasonStore } from 'shared/store/new-year-season.store';

export const useNewYearSeason = () => {
  const isNewYearSeason = useNewYearSeasonStore(state => state.isNewYearSeason);

  useEffect(() => {
    useNewYearSeasonStore.getState().start();
  }, []);

  return isNewYearSeason;
};
